import styled from 'styled-components';

const TooltipHeader = styled.div`
  color: var(--primary-background);
  font-size: 14px;
  font-weight: bold;
`;
export default TooltipHeader;
